import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-fields
gql(`
  fragment AllIntegrationsIntegration on Integration {
    id
    externalId
    platform
    status
    settings {
      enableSso
      enableScim
      enableEnrich
      scimToken
      enableAllParents
      enabledParents
      enableSearch
      enabledSearchSources
      syncingRepos {
        name
        topicId
      }
      importOwnerId
      idpMetadata
    }
    features {
      mention
      profiles
      repoSync
      sso
      saml
      scim
      teamSearch
    }
  }
`);

const ALL_INTEGRATIONS_QUERY = gql(/** @complexity 12 */ `
  query allIntegrations {
    session: currentSession {
      organization {
        id
        integrations {
          ...AllIntegrationsIntegration
        }
      }
    }
  }
`);

export default ALL_INTEGRATIONS_QUERY;
